import { GRID_BREAKPOINTS, GRID_CSS_CLASSES } from '@/constants/dashboard'

export function calculateGridClasses(itemCount: number): string {
  if (itemCount > GRID_BREAKPOINTS.SMALL_MAX_ITEMS && itemCount <= GRID_BREAKPOINTS.MEDIUM_MAX_ITEMS) {
    return GRID_CSS_CLASSES.THREE_COLUMN_RESPONSIVE
  }
  return GRID_CSS_CLASSES.FOUR_COLUMN_RESPONSIVE
}
